import React, { useEffect, useState } from 'react';
import ErrorDialog from './ErrorDialog.comp';

/**
 * GlobalErrorDialog
 *
 * Mounted once at the app root. Listens for the global 'nok-error' window event
 * (dispatched by invokeApi when an API returns a "NOK:" message) and shows the
 * error in a dialog instead of a toast. Covers every page automatically.
 *
 * Event name must stay in sync with bl_libs/invokeApi.js.
 */
export const NOK_ERROR_EVENT = 'nok-error';

const GlobalErrorDialog = () => {
    const [state, setState] = useState({ open: false, message: '' });

    useEffect(() => {
        const handler = (e) => {
            setState({ open: true, message: (e && e.detail) || 'Something went wrong.' });
        };
        window.addEventListener(NOK_ERROR_EVENT, handler);
        return () => window.removeEventListener(NOK_ERROR_EVENT, handler);
    }, []);

    return (
        <ErrorDialog
            isOpen={state.open}
            errorMessage={state.message}
            onClose={() => setState((s) => ({ ...s, open: false }))}
        />
    );
};

export default GlobalErrorDialog;
